var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.40161 42H10.172V20.4211L0.5 10.8305V38.1787C0.5 40.2767 1.80857 42 3.40161 42Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.328 42H40.0984C41.6915 42 43 40.2767 43 38.1787V10.8305L33.328 20.3462",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.328 3.8623V20.4211L43 10.9054V5.73547C43 1.01508 38.9036 -1.68228 36.0589 1.16494",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.172 20.4211V3.8623L21.7784 15.3261L33.328 3.8623V20.4211L21.7215 31.81",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.5 5.73548V10.8305L10.172 20.3462V3.86231L7.4411 1.16495C4.59639 -1.60734 0.5 1.09002 0.5 5.73548Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group(1).e1f70fabc5468080e6c657498065c2c8.svg";
export { ForwardRef as ReactComponent };